<template>
  <div class="container mb-30 paragraph--margin">
    <div
      ref="el"
      class="aspect-[9/16] md:aspect-[1/1] xl:aspect-[16/9] bg-gray-50"
    >
      <iframe
        v-if="iframeUrl?.uri?.path && shouldRender"
        :src="iframeUrl.uri.path"
        class="size-full relative"
        :class="{ 'pointer-events-none': isEditing }"
        :title="$texts('iframeMapBsAccessibilityTitle', 'Interaktive Karte')"
        allowfullscreen
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphMapBsIframeFragment } from '#graphql-operations'

const { isEditing } = defineBlokkli({
  bundle: 'mapbs_iframe',
  globalOptions: ['bkVisibleLanguages'],
  chunkName: 'rare',
})

const el = ref<HTMLDivElement | null>(null)
const shouldRender = useRenderWhenVisible(el)

defineProps<{
  iframeUrl?: ParagraphMapBsIframeFragment['iframeUrl']
}>()

defineOptions({
  name: 'ParagraphMapbsIframe',
})

useCDNHeaders((v) => v.addTags(['nuxt:content:iframe']))
</script>
